import * as Yup from "yup";
import { AddressInputSchema } from "../common/SharedAddressInput/schemas";
import { createIndividualInformationInputSchema } from "../IndividualInformationInput/schemas";

export interface IndividualProfileFormValues {
  firstName: string;
  middleName?: string;
  lastName: string;
  dateOfBirth: Date;
  identificationNumber: string;
  streetLine1: string;
  streetLine2?: string;
  city: string;
  state: string;
  province?: string;
  zip?: string;
  country: string;
}
export const createIndividualProfileSchema =
  (): Yup.ObjectSchema<IndividualProfileFormValues> =>
    Yup.object({
      ...createIndividualInformationInputSchema.fields,
      ...AddressInputSchema.fields,
    }) as Yup.ObjectSchema<IndividualProfileFormValues>;
